import React from "react";
import "./BestOfCube.scss";
import { useContext } from "react";
import { AppContext } from "../../stores/application.store";
import { useEffect } from "react";
const BestOfCube = (props) => {
  const { bestSinger, setBestSinger } = useContext(AppContext);
  useEffect(() => {
    window.singers = bestSinger;
  }, []);
  return (
    <div className="best-of-cube">
      <div
        onClick={() =>
          bestSinger[0] == props.artist.ID
            ? setBestSinger([0])
            : setBestSinger([props.artist.ID])
        }
        className={`best-of-image ${
          bestSinger[0] == props.artist.ID ? "checked" : ""}
          image-${props.artist.ID + 166}
          `}
      >
                  {!bestSinger.includes(props.artist.ID) &&
            !bestSinger.includes(0) && <div className="fade"></div>}
        <div
          className={`check-button`}
          onClick={() =>
            bestSinger[0] == props.artist.ID
              ? setBestSinger([0])
              : setBestSinger([props.artist.ID])
          }
        >
          <div className="desktop-only">בחירה</div>

        </div>
      </div>
      <h4 className="best-of-name">{props.artist.Name}</h4>
    </div>
  );
};

export default BestOfCube;
